<template>
  <div class="main">
    <Header/>
    <div class="content">
      <Logo subTitle="Captura De Solicitud De Prestamos" description="Ingresar los 13 caracteres del R.F.C. y tu NIP como en el módulo de información del FAS." />
      <Access/>
    </div>
  </div>
</template>

<script>

import Header from '@/components/Header/Header.vue'
import Logo from '@/components/PreRequestLoan/Logo.vue'
import Access from '@/components/PreRequestLoan/Access.vue'

export default {
  data() {
    return {

    }
  },
  components: {
    Header,
    Logo,
    Access,
  }
}
</script>

<style scoped>
.main {
  @apply grid grid-cols-1 gap-4;
}
.content {
  padding:30px;
}
</style>
